import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToggleService } from './core/layout/header/toggle.service';
import { AuthenticationService } from './core/service/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'seyerli-web';
  isToggled = false;

  constructor(
    readonly router: Router,
    readonly authenticationService: AuthenticationService,
    private toggleService: ToggleService,
  ) {
    this.toggleService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }
}
